module.exports = __webpack_public_path__ + "img/icon01.bec9aa7e.png";